import { FC, useState, useEffect, SyntheticEvent } from "react";
import { TabContext, TabList } from "@mui/lab";
import { load, remove } from "../../constants/storage";
import { Box, Grid, Tab, styled } from "@mui/material";
import DashboardNavbar from "../../components/DashboardNavbar";
import FlexBox from "../../components/FlexBox";
import GoldSilverTransaction from "../goldSilverScreens/GoldSilverTransaction";
import MFTransaction from "../mfScreens/MFTransaction";
import { useNavigate, useLocation } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-hot-toast";
const TransactionScreen: FC = () => {
  let routeData = useLocation();
  const { type } = routeData.state;
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(type === "mutualFund" ? "2" : "1");
  const handleChange = (_: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  let navigate = useNavigate();
  useEffect(() => {
    checkToken();
  }, []);
  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      return null;
    }
  };
  const StyledTab = styled(Tab)(({ theme }) => ({
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontFamily: "'Poppins', sans-serif",
    textTransform: "none",
    [theme.breakpoints.up("sm")]: {
      "& .MuiTabs-flexContainer": {
        fontSize: 10,
        fontWeight: 600,
        color: theme.palette.text.primary,
        fontFamily: "'Poppins', sans-serif",
      },
    },
  }));

  const StyledTabList = styled(TabList)(({ theme }) => ({
    [theme.breakpoints.down(780)]: {
      width: "100%",
      "& .MuiTabs-flexContainer": {
        justifyContent: "space-between",
      },
    },
    [theme.breakpoints.up("sm")]: {
      "& .MuiTabs-flexContainer": {
        minWidth: 200,
        justifyContent: "space-between",
      },
    },
  }));

  return (
    <Grid
      container
      sx={{
        background: "#F6F6F6",
        flexDirection: "column",
        display: "flex",
      }}
    >
      <DashboardNavbar />
      {loading ? (
        <Grid
          height="100%"
          display="flex"
          flexDirection="column"
          sx={{ display: "flex", alignItems: "center", mt: 20, mb: 40 }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <>
          <TabContext value={value}>
            <Box sx={sxStyleTabBox}>
              <FlexBox
                padding="0"
                alignItems="center"
                justifyContent="space-between"
              >
                <StyledTabList onChange={handleChange}>
                  <StyledTab label="Gold/Silver" value="1" />
                  <StyledTab label="Mutual Funds" value="2" />
                </StyledTabList>
              </FlexBox>
              {loading ? (
                <Grid
                  height="100%"
                  display="flex"
                  flexDirection="column"
                  sx={{
                    display: "flex",
                    mt: 30,
                    mb: 40,
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </Grid>
              ) : (
                <>
                  {value === "1" && <GoldSilverTransaction />}
                  {value === "2" && <MFTransaction />}
                </>
              )}
            </Box>
          </TabContext>
        </>
      )}
    </Grid>
  );
};

export default TransactionScreen;
const sxStyleTabBox = {
  pl: {
    xs: 1,
    sm: 1,
    md: 10,
  },
  pr: {
    xs: 1,
    sm: 1,
    md: 10,
  },
};
